function repairOption(highlightbutton, showthisoption) {
  $('.newrepairoptionsbutton').removeClass('active');
  $('.newrepairoptions').removeClass('active');
  $('.newrepairoptions').hide();
  $('#' + showthisoption).show();
  $('#' + showthisoption).addClass('active');
  $('#' + highlightbutton).addClass('active');
  var scrollid = showthisoption;   
  var elem = document.getElementById(scrollid);
  elem.scrollIntoView();

}
///////////////////////////////////////////////////////////////////
jQuery(document).ready(function ($) {
  var cfg = window.repairConfig || {};
  if (cfg.postInPackVariantId) {
    $.getJSON('/variants/' + cfg.postInPackVariantId + '.js', function (v) {
      if (!v || typeof v.price === 'undefined') return;
      var priceMoney = (v.price / 100).toFixed(2);
      var $mailInHeader = $('.choose-service-box.mail-in .repair--tab-header');
      $mailInHeader.attr('data-sprice', priceMoney);     
    });
  }
  if (cfg.callOutServiceVariantId) {
    $.getJSON('/variants/' + cfg.callOutServiceVariantId + '.js', function (v) {
      if (!v || typeof v.price === 'undefined') return;
      var priceMoney = (v.price / 100).toFixed(2);
      var $callOutHeader = $('.choose-service-box.call-out .repair--tab-header');
      $callOutHeader.attr('data-sprice', priceMoney);      
    });
  }
  /**upsel code starts here */
  $(document).on('change', '.upsell-checkbox', function () {
    let upsells = [];

    $('.upsell-checkbox:checked').each(function () {
      upsells.push($(this).val());
    });

    sessionStorage.setItem('upsells', JSON.stringify(upsells));
  });
  /**upsel code ends here */

  $('.part-select-btn').on('click', function () {
    /**Upsell products code starts here */
    sessionStorage.removeItem('upsell_products');

    // also reset UI if needed
    $('.upsell-checkbox').prop('checked', false);
    /**Upsell products code ends here */

    $('.book_repair_popup').addClass('modal-open');
    var p_id = $(this).data('id');
    var varient_id = $(this).data('varient_id');
    //var price = $(this).data('price');
    var variantSelector = $('#varient_' + p_id);
    var selectedVal = variantSelector.length ? variantSelector.val() : varient_id;
    // 🔥 get price dynamically from button (already updated by your JS)
    //var price = $(this).attr('data-price');
    var price = $(this).closest('.image-media').find('.price .money').text();
    var title = $(this).data('title');
    var image = $(this).data('image');
    //var varients_id = $('#varient_' + p_id).val();
    var colors = '';
    var optionName = '';
    //var colors = $('.varient_selected_id').find('option:selected').text();
    //var colors = $('#varient_' + p_id + ' option:selected').text();
    //new colors code to stop it from sending empty string for non-variable product.
    if (variantSelector.length > 0) {
      colors = variantSelector.find('option:selected').text().trim();
      optionName = variantSelector.data('option-name') || '';
    }
    
    //sessionStorage.clear();
    sessionStorage.removeItem('product_price');
    sessionStorage.removeItem('varient_id');
    if (colors) {
      sessionStorage.setItem('colors', colors);
    } else {
      sessionStorage.removeItem('colors');
    }
    if (optionName) {
      sessionStorage.setItem('option_name', optionName);
    } else {
      sessionStorage.removeItem('option_name');
    }
    /*if (varients_id) {
      var_id = varients_id;
    } else {
      var_id = varient_id;
    }*/
   if (variantSelector.length > 0) {
      var selectedVal = variantSelector.val();
      var_id = selectedVal ? selectedVal : varient_id;
    } else {
      var_id = varient_id;
    }
    var currentURL = window.location.href;
    sessionStorage.setItem('product_id', p_id);
    sessionStorage.setItem('colors', colors);
    sessionStorage.setItem('varient_id', var_id);
    sessionStorage.setItem('product_price', price);
    sessionStorage.setItem('product_title', title);
    sessionStorage.setItem('product_image', image);
    sessionStorage.setItem('collection_url', currentURL);

  });
///////////////////////////////////////////////////////////////////
  $('.btn-main').click(function () {
    $('.container').removeClass('modal-open');
    sessionStorage.clear();
  });
  ///////////////////////////////////////////////////////////////////
  $('.btn-store').click(function () {
    $('#section1').show();
    $('#section_mail_in').hide();
    $('#section_call_out').hide();
    $('#section_walk_in').hide();
    $(this).hide();
    $('.btn-main').show();
    PreviewsStep();
  });
  
  $('.previouslink').on('click', function () {

  var service = sessionStorage.getItem('service');

  if (service === 'Visit Store') {

    // 1. Clear session
    sessionStorage.removeItem('datetime');

    // 2. Clear input value
    $('#datetimepicker').val('');

    // 3. 🔥 RESET DATETIMEPICKER INTERNAL STATE
    $('#datetimepicker').datetimepicker('reset');
  }

});
 
  $('.btn-order').click(function () {
    /**Upsel products code starts here */
    sessionStorage.removeItem('upsell_products');
    $('.upsell-checkbox').prop('checked', false);
    /**Upsel products code ends here */
    var service = sessionStorage.getItem('service');
    if (service == 'Post Out Service') {
      $('#section_mail_in').show();
    } else if (service == 'Call Out Service') {
      $('#section_call_out').show();
    } else {
      $('#section_walk_in').show();
    }
    $('#booking_summary').hide();
    $(this).hide();
    $('.btn-store').show();
    PreviewsStep();
  });

  $('.walk-in').on('click', function () {
    $('#emailmarketingbox').hide();
    $('#postcode_callout').hide();
    
     sessionStorage.removeItem('service_price');
     sessionStorage.setItem("service", "Visit Store");
   
        $(".btn-main").hide();
        $("#section1").hide();
        $("#section_walk_in").show();
        $(".btn-store").show();
        nextStep();
  });
///////////////////////////////////////////////////////////////////
  $('.mail-in').on('click', function () {
    sessionStorage.setItem('service', 'Post Out Service');
    var price = $(this).find('.repair--tab-header').data('sprice');
    sessionStorage.setItem('service_price', price);
    $('#section1').hide();
    $('#section_mail_in').show();
    $('.btn-main').hide();
    $('.btn-store').show();
    nextStep();
  });
///////////////////////////////////////////////////////////////////
  $('.call-out').on('click', function () {
    sessionStorage.setItem('service', 'Call Out Service');
    var price = $(this).find('.repair--tab-header').data('sprice');
    sessionStorage.setItem('service_price', price);
    $('#postcode_callout').show();
    $('#emailmarketingbox').hide();
    $('.modal').animate({
      scrollTop: $('#postcode_callout').offset().top - 100
    }, 800);
  });
/////////////////////////////*//////////////////////////////////////
  // $('#walk_in_btn').on('click', function () {   
  //   // var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   // var email = $("#walk_in_email").val();
  //    sessionStorage.removeItem('service_price');
  //   // if (email) {
  //   //   if (emailRegex.test(email)) {
  //       sessionStorage.setItem("service", "Visit Store");
  //    //   sessionStorage.setItem("email", email);
  //       $(".btn-main").hide();
  //       $("#section1").hide();
  //       $("#section_walk_in").show();
  //       $(".btn-store").show();
  //       nextStep();
  //   //   } else {
  //   //     $('#info_msg').text('Invalid email address');
  //   //   }
  //   // } else {
  //   //   $("#info_msg").text('Please enter an email address');
  //   // }
  // });
   ///////////////////////////////////////////////////////////////////

$('#call_out_service_btn').on('click', function() {
  var postcode = $("#postoutcode").val();
  if(postcode){ 
     sessionStorage.setItem("postcode",postcode);
     sessionStorage.setItem("service","Call Out Service");
    var destination = "BL22DL";
    
    // Define your Google Distance Matrix API key
    var apiKey = "AIzaSyAS8Oyp0aVjQ-dUCrneWS39I_vECHaBQg0";

    // Construct the API request URL
    var url2 = "https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=" + postcode + "&destinations=" + destination + "&key=" + apiKey;


    if (postcode && destination) {
            var service = new google.maps.DistanceMatrixService();
            service.getDistanceMatrix({
                origins: [postcode],
                destinations: [destination],
                travelMode: 'DRIVING',  // You can change to WALKING, BICYCLING, TRANSIT, etc.
                unitSystem: google.maps.UnitSystem.IMPERIAL,
            }, function (response, status) {
                if (status === 'OK') {
                    var results = response.rows[0].elements;
                     console.log(results);
                    var distanceText = results[0].distance.text;
                  const distanceValue = results[0].distance.value; 
                  const miles = distanceValue / 1609.34; // Convert meters to miles
                  if(miles <= 20){
                    sessionStorage.setItem("Distance",miles);
                  // $("#distance").html(miles);
                   $("#section1").hide();
                  $("#section_call_out").show(); 
                   $(".btn-main").hide();
                  $(".btn-store").show();
                  nextStep();     
                } else {
                    $("#distance").html('Call Out Service not available in your area');
                }
                }
            
            });
        } else {
            $("#distance").html("Please enter postcode.");
        }

    
    
    
 
     

  }else{
    $("#info_msg").text('Please enter an email address');
  }
});
  
  ///////////////////////////////////////////////////////////
  var baseAllowTimes = [
    '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
    '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
    '15:00', '15:30', '16:00', '16:30', '17:00', '17:30'
  ];

  function updateAllowTimesForToday(dp, ct) {
    var now = new Date();
    var todayStr = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);
    var selected = ct ? ct : now;
    var selectedStr = selected.getFullYear() + '-' + ('0' + (selected.getMonth() + 1)).slice(-2) + '-' + ('0' + selected.getDate()).slice(-2);

    if (selectedStr === todayStr) {
      // Round current time up to the next 30-minute slot
      var currentMinutes = now.getHours() * 60 + now.getMinutes();
      var rounded = Math.ceil(currentMinutes / 30) * 30;

      // If we've passed the last slot, effectively disable today by setting a very late minTime
      var lastSlotMinutes = 17 * 60 + 30; // 17:30
      var minTimeStr;
      if (rounded > lastSlotMinutes) {
        minTimeStr = '23:59';
      } else {
        var minH = Math.floor(rounded / 60);
        var minM = rounded % 60;
        minTimeStr = ('0' + minH).slice(-2) + ':' + ('0' + minM).slice(-2);
      }

      dp.setOptions({
        allowTimes: baseAllowTimes,
        minTime: minTimeStr
      });
    } else {
      dp.setOptions({
        allowTimes: baseAllowTimes,
        minTime: false
      });
    }
  }

  $('#datetimepicker, #datetimecallpicker').datetimepicker({
           inline: true, // Render as inline calendar
           format: 'Y-m-d H:i', // Format of datetime
           step: 30, // Time slot interval in minutes
           allowTimes: baseAllowTimes,
           minDate: 0,
           onShow: function(ct) {
             updateAllowTimesForToday(this, ct);
           },
           onSelectDate: function(ct) {
             updateAllowTimesForToday(this, ct);
           },
           onSelectTime: function(ct) {
             // Extra safety: prevent selecting a past time on today
             var now = new Date();
             var nowTime = now.getTime();
             var selectedTime = ct.getTime();
             var isSameDay = now.getFullYear() === ct.getFullYear() &&
               now.getMonth() === ct.getMonth() &&
               now.getDate() === ct.getDate();

             if (isSameDay && selectedTime <= nowTime) {
               $(this).val('');
                this.setOptions({ value: false });

                //sessionStorage.removeItem('datetime');

                // 🔥 IMPORTANT: mark invalid state explicitly
                sessionStorage.setItem('datetime_invalid', '1');
                $('#datetimepicker').datetimepicker('reset');
                updateAllowTimesForToday(this, new Date());

                alert('Please choose a time in the future.');

                return false;

             }else {
              sessionStorage.setItem('datetime', ct);
              sessionStorage.removeItem('datetime_invalid');
            }
           }
        });
        
////////////////////////////////////////////////////////////////////
 $('#store_select_walkin,#mail_in_btn').on('click', function () {
      var invalid = sessionStorage.getItem('datetime_invalid');

      if (invalid === '1') {
        alert('Please select a valid future time before continuing.');
        return;
      }
     var service = sessionStorage.getItem('service');

      if(service == 'Visit Store'){
        var date_time = $('#datetimepicker').val();

        if(!date_time || !date_time.includes(':')){
          alert('Please select a date and time');
          return;
        }
      }

      $('#section_walk_in,#section_mail_in,#section_call_out').hide();
      $('#booking_summary').show();
       var service = sessionStorage.getItem('service');
        if(service == 'Visit Store'){
          var date_time = $('#datetimepicker').val();
          if(!date_time){
            alert('Please select a date and time');
            return;
          }
        }else if(service == 'Call Out Service'){
          var date_time = $('#datetimecallpicker').val();
        }
      var product_name = sessionStorage.getItem('product_title');
      sessionStorage.setItem('datetime', date_time);
      var product_price = sessionStorage.getItem('product_price');
      var product_image = sessionStorage.getItem('product_image');
      var product_id = sessionStorage.getItem('product_id');
      var datetime = sessionStorage.getItem('datetime');
      var service = sessionStorage.getItem('service');
      var colors = sessionStorage.getItem('colors');
      var optionName = sessionStorage.getItem('option_name');
      var  sprice = sessionStorage.getItem('service_price');

      // Normalise prices: remove currency symbols/commas, then parse as numbers
      var productPriceNum = parseFloat(String(product_price).replace(/[^0-9.]/g, '')) || 0;
      var servicePriceNum = parseFloat(String(sprice).replace(/[^0-9.]/g, '')) || 0;
      var total = productPriceNum + servicePriceNum;
      $('#product_image').attr('src', product_image);
      $('#product_image').attr('alt', product_name);
      $('#product_name').text(product_name);
      $('#delivary_product_time').show();
      $('#delivary_product_datetime').text(datetime);
      $('#product_price_main').text(product_price);
      //$('#delivary_service').text(service);
      var serviceLabel = service;
      if (service === 'Post Out Service') {
        serviceLabel = 'Mail-in Service';
      } else if (service === 'Call Out Service') {
        serviceLabel = 'Call Out Service';
      } else if (service === 'Visit Store') {
        serviceLabel = 'Visit Us';
      }
      $('#delivary_service').text(serviceLabel);
      
      $('.repair-service,.serviceImage').hide();
      if(service == 'Visit Store'){
        $('#walk_in_service, #walk_in,#delivary_product_time').show();
        $('#service_cost').hide();            
      }else if(service == 'Call Out Service'){
        $('#call_out_service, #call_out,#delivary_product_time,#service_cost').show();
        $('#service_cost_price').text('£' + servicePriceNum.toFixed(2));
        $('#walk_in, #mail_in').hide();
      }else{
        $('#delivary_product_time').hide();
        $('#mail_in_service, #mail_in,#service_cost').show();
        $('#service_cost_price').text('£' + servicePriceNum.toFixed(2));
      }
      //$('#product_colors_main').text(colors);
      //to fetch variation title 
      var productId = sessionStorage.getItem('product_id');
      var variantTitle = sessionStorage.getItem('colors'); // already storing the variant title

      // Fetch product JSON to get the option names
      fetch('/products/' + variantTitle.toLowerCase().replace(/[^a-z0-9]+/g,"-") + '.js')
        .then(res => res.json())
        .then(product => {
          if (product.options && variantTitle) {
            var values = variantTitle.split(' / '); // "Red / XL" → ["Red", "XL"]
            var labels = product.options.map((optName, idx) => {
              return values[idx] ? `${optName}: ${values[idx].trim()}` : '';
            });
            $('#product_colors_main').text(labels.filter(l => l).join(', '));
          } else {
            $('#product_colors_main').text(variantTitle);

            if (optionName) {
              $('#colors_product_item strong').text(optionName + ':');
            }
          }
        })
        .catch(() => {
          // fallback: show the variant title as-is
          $('#product_colors_main').text(variantTitle);

          if (optionName) {
            $('#colors_product_item strong').text(optionName + ':');
          }
        });
     //variation title fetch code ends here
      $('#total_product_price').text('£' + total.toFixed(2));
      $('#product_ids').val(product_id);
      $('#prod_delivery_date').val(datetime);
      $('#prod_service').val(service);      
      $('.btn-store').hide();
      $('.btn-order').show();
      /*if (colors) {
        $('#colors_product_item').show();
      }*/
     if (colors) {
        $('#colors_product_item').show();
      } else {
        $('#colors_product_item').hide();
      }
      nextStep();
    });
 
//////////////////////////////////////////////////////////////////
 $('#confirmbookingbutton').on('click', function() {  
   if($("#customer_terms").prop('checked') == true){   
    var varient_id = sessionStorage.getItem("varient_id");    
    var datetime = sessionStorage.getItem("datetime");
    var service = sessionStorage.getItem("service");    
     $(".form-errors").hide();
     updateOrderMetafieldOnAddToCart(varient_id, service,datetime);
   }else{
    $(".form-errors").text('Please read and accept the terms and conditions');
     $(".form-errors").show();
  }
});
//////////////////////////////////////////////////////////////////
});
//////////////////////////////////////////////////////////////////

function nextStep() {
  var currentStepNum = $('#checkout-progress').data('current-step');
  var nextStepNum = currentStepNum + 1;
  var currentStep = $('.step.step-' + currentStepNum);
  var nextStep = $('.step.step-' + nextStepNum);
  var progressBar = $('#checkout-progress');
  $('.btn-prev').removeClass('disabled');
  if (nextStepNum == 4) {
    $(this).toggle();
    $('.btn-submit').toggle();
  }
  $('.checkout-progress')
    .removeClass('.step-' + currentStepNum)
    .addClass('.step-' + (currentStepNum + 1));
  currentStep.removeClass('active').addClass('valid');
  currentStep.find('span').addClass('opaque');
  currentStep.find('.fa.fa-check').removeClass('opaque');
  nextStep.addClass('active');
  progressBar
    .removeAttr('class')
    .addClass('step-' + nextStepNum)
    .data('current-step', nextStepNum);
}
/////////////////////////////////////////////////////////////
function updateOrderMetafieldOnAddToCart(productId, service, datetime) {
  var config = window.repairConfig || {};
  var postInPackId = config.postInPackVariantId;
  var callOutServiceId = config.callOutServiceVariantId;

  // Always remove any existing service-charge items first,
  // in case the customer changed service and is booking again.
  var updateData = {};
  if (postInPackId) {
    updateData['updates[' + postInPackId + ']'] = 0;
  }
  if (callOutServiceId) {
    updateData['updates[' + callOutServiceId + ']'] = 0;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: updateData,
    complete: function () {
      var items = [
        {
          id: productId,
          quantity: 1,
          properties: {
            'order.metafields.order.delivary_date': datetime,
            'order.metafields.order.service': service
          }
        }
      ];
      /** Upsell products code starts here */
      // Add selected upsells
      var upsells = JSON.parse(sessionStorage.getItem('upsells') || '[]');

      upsells.forEach(function(id) {
        items.push({
          id: id,
          quantity: 1
        });
      });
      /** Upsell Products code ends here */
      if (service === 'Post Out Service' && postInPackId) {
        items.push({ id: postInPackId, quantity: 1 });
      } else if (service === 'Call Out Service' && callOutServiceId) {
        items.push({ id: callOutServiceId, quantity: 1 });
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: items },
        dataType: 'json',
        complete: function () {
          /**upsell code starts here */
          sessionStorage.removeItem('upsells'); // clear after use
          /**upsell code ends here */
          window.location.href = '/cart?id=' + productId;
        },
        error: function (xhr, status, error) {
          console.error('Error adding items to cart:', error);
        }
      });
    }
  });
}
/////////////////////////////////////////////////////////////
 function PreviewsStep() {
      var currentStepNum = $('#checkout-progress').data('current-step');
      var prevStepNum = currentStepNum - 1;
      //  $("#emailmarketingbox").hide();
      var currentStep = $('.step.step-' + currentStepNum);
      var prevStep = $('.step.step-' + prevStepNum);
      var progressBar = $('#checkout-progress');
      $('.btn-next').removeClass('disabled');
      //$('#section'+currentStepNum).toggle();
      //$('#section'+prevStepNum).toggle();
      if (currentStepNum == 4) {
        $('.btn-submit').toggle();
        $('.btn-next').toggle();
      }
      if (currentStepNum == 1) {
        return false;
      }
      if (prevStepNum == 1) {
        $(this).addClass('disabled');
      }
      $('.checkout-progress')
        .removeClass('.step-' + currentStepNum)
        .addClass('.step-' + prevStepNum);

      currentStep.removeClass('active');
      prevStep.find('span').removeClass('opaque');
      prevStep.find('.fa.fa-check').addClass('opaque');

      prevStep.addClass('active').removeClass('valid');
      progressBar
        .removeAttr('class')
        .addClass('step-' + prevStepNum)
        .data('current-step', prevStepNum);
    }

    //New call out section code
    $('#call_out_continue_btn').on('click', function () {
  $('#section_call_out').hide();
  $('#booking_summary').show();
  $('#walk_in, #call_out, #mail_in').hide();
  $('#walk_in_service, #call_out_service, #mail_in_service').hide();
  $('#service_cost').hide();
  $('#delivary_product_time').hide();
  
  sessionStorage.setItem('datetime', '');

  var product_name = sessionStorage.getItem('product_title');
  var product_price = sessionStorage.getItem('product_price');
  var product_image = sessionStorage.getItem('product_image');
  var product_id = sessionStorage.getItem('product_id');
  var service = sessionStorage.getItem('service');
  var colors = sessionStorage.getItem('colors');
  var optionName = sessionStorage.getItem('option_name');
  var sprice = sessionStorage.getItem('service_price');

  var productPriceNum = parseFloat(String(product_price).replace(/[^0-9.]/g, '')) || 0;
  var servicePriceNum = parseFloat(String(sprice).replace(/[^0-9.]/g, '')) || 0;
  var total = productPriceNum + servicePriceNum;

  $('#product_image').attr('src', product_image);
  $('#product_name').text(product_name);
  $('#product_price_main').text(product_price);
  $('#delivary_service').text(service);
  $('#service_cost_price').text('£' + servicePriceNum.toFixed(2));
  $('#total_product_price').text('£' + total.toFixed(2));

  $('#call_out_service, #call_out, #service_cost').show();
  $('#delivary_product_time').hide();

  $('.btn-store').hide();
  $('.btn-order').show();

  nextStep();
});